var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfinite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 9,
    viewBox: "0 0 20 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 0.00012207C14.3 0.00012207 13.1667 0.466802 12.3542 1.2793L10 3.36262L9.99582 3.35844L8.73332 4.47094L8.74164 4.47926L6.49582 6.47094C5.9625 7.00012 5.25418 7.2918 4.5 7.2918C2.94168 7.2918 1.675 6.0293 1.675 4.4793C1.675 2.9293 2.94168 1.6668 4.5 1.6668C5.25418 1.6668 5.9625 1.95848 6.53332 2.52512L7.47914 3.36262L8.73746 2.25012L7.68328 1.3168C6.83328 0.470981 5.7041 0.00430214 4.49996 0.00430214C2.01668 0.000122457 0 2.00848 0 4.4793C0 6.95012 2.01668 8.95848 4.5 8.95848C5.7 8.95848 6.82918 8.4918 7.64582 7.68348L10 5.59598L10.0042 5.60016L11.2625 4.48348L11.2583 4.4793L13.5041 2.4918C14.0375 1.95848 14.7458 1.6668 15.5 1.6668C17.0583 1.6668 18.325 2.9293 18.325 4.4793C18.325 6.0293 17.0583 7.2918 15.5 7.2918C14.7458 7.2918 14.0375 7.00012 13.4667 6.43762L12.5209 5.60012L11.2625 6.7168L12.3167 7.65012C13.1667 8.49594 14.2959 8.95844 15.4959 8.95844C17.9833 8.95848 20 6.95012 20 4.4793C20 2.00848 17.9833 0.00012207 15.5 0.00012207Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfinite);
export default __webpack_public_path__ + "static/media/infinite.1d3dba3f.svg";
export { ForwardRef as ReactComponent };